import Quill from "./myQuill";
export default function(editor) {
    this.editor = editor
    let position = ''
    this.getRangeNode = () => {
        const selection = window.getSelection()
        return selection.focusNode // 选择的结束节点
    }
    this.showAt = () => {
        const node = this.getRangeNode()
        if (!node || node.nodeType !== Node.TEXT_NODE) return false
        const content = node.textContent || ''
        const regx = /@([^@\s]*)$/
        const match = regx.exec(content.slice(0, this.getCursorIndex()))
        return match && match.length === 2
    }
    this.getCursorIndex = () => {
        const selection = window.getSelection()
        return selection.focusOffset // 选择开始处 focusNode 的偏移量
    }
    // 弹窗出现的位置
    this.getRangeRect = () => {
        const selection = window.getSelection()
        const range = selection.getRangeAt(0) // 是用于管理选择范围的通用对象
        const rect = range.getClientRects()[0] // 择一些文本并将获得所选文本的范围
        // const LINE_HEIGHT = 30
        return {
            x: rect.x,
            y: rect.y
        }
    }
    // 获取 @ 用户
    this.getAtUser = () => {
        const content = this.getRangeNode().textContent || ''
        const regx = /@([^@\s]*)$/
        const match = regx.exec(content.slice(0, this.getCursorIndex()))
        if (match && match.length === 2) {
            return match[1]
        }
        return ''
    }
    // 插入===============
    this.replaceAtUser = (user, {id, name}, atKeyword, type) => {
        let quill = this.editor;
        let cursorPosition = quill.selection.savedRange.index; // 获取原来光标位置
        // if (type == 'enter') {
        //     cursorPosition = cursorPosition -1
        // }
        let mentionStartAt = cursorPosition - atKeyword.length - 1
        this.editor.deleteText(mentionStartAt, atKeyword.length + 1);
        quill.insertEmbed(mentionStartAt, 'atTag', {id, name}, Quill.sources.USER);
        quill.setSelection(mentionStartAt + 1, Quill.sources.USER);

        // const quillRange = this.editor.getSelection(true);
        // let cursorPosition = quillRange.index;
        // let content1 = this.editor.getText(),
        //     contentLength1 = content1.length
        // if (type == 'enter') {
        //     contentLength1 = contentLength1 - 1
        //     cursorPosition = cursorPosition -1
        // }
        // let end = contentLength1 - cursorPosition
        // let mentionStartAt = cursorPosition - atKeyword.length - 1
        // this.editor.deleteText(mentionStartAt, atKeyword.length + 1);
        // this.editor.insertEmbed(mentionStartAt, 'atTag', {id, name}, Quill.sources.USER);
        // const content = this.editor.getText();
        // this.editor.setSelection(content.length - end, 0, 'api');
        // this.editor.getSelection(true)
    }
    this.insertEmoji = ({str,src}) => {
       
        let quill = this.editor;
        let cursorPosition = quill.selection.savedRange.index; // 获取原来光标位置
        console.log(cursorPosition,"cursorPosition==============")
        // let mentionStartAt = cursorPosition - str.length - 1
        // console.log(mentionStartAt,"mentionStartAt==============")
        quill.insertEmbed(cursorPosition, 'emojiTag', {src}, Quill.sources.USER);
        quill.setSelection(cursorPosition + 1, Quill.sources.USER);

    }
}